import { JDSDatepickerYearViewProps } from './generated';

export const withLogic =
  (Component: React.ComponentType<any>): React.FC<any> =>
  (props: JDSDatepickerYearViewProps) => {
    return (
      <Component
        {...{
          ...props,
          onSelect: (i: number) => {
            props?.onSelect?.(props.loadedYears?.[i - 1]?.value);
          }
        }}
      />
    );
  };
